import styled from 'styled-components';

export default styled.p`
  ${props => props}
  font-size: ${props => props.theme.old.fontSize[props.size] || props.theme.old.fontSize.display4};
  color: ${props => props.theme.old.colors[props.bg] || props.theme.old.colors.transparent};
  font-weight: ${props => props.theme.old.fonts.weight[props.weight] || props.theme.old.fonts.weight.bold};
  -webkit-text-stroke: 2px ${props => props.theme.old.colors[props.color] || props.theme.old.colors.white};
  position: ${props => props.position || 'sticky'};

  ::selection {
    background-color: ${props => props.theme.old.colors.primary};
    color: ${props => props.theme.old.colors.white};
  }

  ${props => props.theme.old.is.isTab}{
    font-size: ${props => props.theme.old.fontSize[props.size] || props.theme.old.fontSize.display1};
  }
`;